import { Component } from "react";
import { Container } from "unstated";

interface IState {
  component: Component | null;
  props: {};
}

const initalState: IState = {
  component: null,
  props: {}
};

class ModalContainer extends Container<IState> {
  public state = initalState;

  public showModal = (component: Component, props = {}) =>
    this.setState({ component, props });

  public hideModal = () => this.setState(initalState);
}

export default ModalContainer;
